<template>
<iframe src="../../../../../public/csv/Category.csv" class="w-100" height="400"></iframe>
</template>

<script>
import {
  BRow,
  BCol,
  BForm,
  BFormInput,
  BFormTextarea,
  BFormSelect,
  BFormDatepicker,
  BFormGroup,
  BButton,
  BSpinner
} from "bootstrap-vue";

export default {
  name: "ViewDocument",
  components: {
    BRow,
    BCol,
    BForm,
    BFormInput,
    BFormTextarea,
    BFormSelect,
    BFormDatepicker,
    BFormGroup,
    BButton,
    BSpinner
  },
  data() {
    return {
     
    };
  },
};
</script>
